import en from './en';
import fr from './fr';

const LANGS = ["fr", "en"];
const CHOSEN_KEY = "lang_chosen";
const PREFERENCE_LANGS = {
    french: "fr", fr: "fr", francais: "fr", "français": "fr",
    english: "en", en: "en", anglais: "en",
};

/** The interface language for a firm's `language_preference`, or null when it names none. */
export function languageFromPreference(preference) {
    return PREFERENCE_LANGS[String(preference || "").trim().toLowerCase()] || null;
}

export default class Translator {
    constructor(defaultLang = "en") {
        this.locales = {};
        this.listeners = [];

        this.locales["en"] = en;
        this.locales["fr"] = fr;

        this.lang = defaultLang;

        // A key never saved reads as undefined, not null: start from the device language instead of English.
        const saved = window.localStorage["lang"];
        this.changeLang(LANGS.includes(saved) ? saved : defaultLang);
    }

    /** True once the person picked a language with the switch; their choice then outranks the firm preference. */
    static userChoseLang() {
        return window.localStorage[CHOSEN_KEY] === "1";
    }

    onLangChange(callback) {
        this.listeners.push(callback);
    }

    offLangChange(callback) {
        this.listeners = this.listeners.filter(fn => fn !== callback);
    }

    notifyLangChange() {
        this.listeners.forEach(fn => fn(this.lang));
    }

    switchLang() {
        window.localStorage[CHOSEN_KEY] = "1";
        this.lang = this.lang === "en" ? "fr" : "en";
        this.changeLang(this.lang);
    }

    changeLang(lang) {
        this.lang = ["fr", "en"].includes(lang) ? lang : "en";
        window.localStorage["lang"] = this.lang;
        this.notifyLangChange();
    }

    get(key) {
        return this.locales[this.lang][key];
    }

    getCurrentLang() {
        return this.lang;
    }

    read(key) {
        if (window.localStorage["lang"] === null || !["fr", "en"].includes(window.localStorage["lang"])) {
            this.changeLang(this.lang);
        }

        const arr = key.split(".");
        let obj = this.locales[this.lang];

        for (const part of arr) {
            if (obj == null) return undefined;
            obj = obj[part];
        }

        return obj;
    }
}